// extracted by mini-css-extract-plugin
export default {"btn":"btn__demFt","content":"content__BWC+A"};